import ACCESS_SCOPE_ENUM from '@tenant/utility/constants/AppEnum/ACCESS_SCOPE_ENUM';
import { PRICE_TYPE_ENUM } from '@tenant/utility/constants/enum';
import { generateUUID } from '@tenant/utility/helper/Utils';

export const initialValuesStepInformation = {
  Name: '',
  ShortDescription: '',
  LongDescription: '',
  AppUrl: '',
  KeyBenefits: '',
  KeyLabels: '',
  Platform: 1,
  LaunchType: 1,
  IntegrationMode: 1,
  IsLegacy: true,
  IconBlobReference: '',
  AuthorId: null,
  CreatedBy: '',
  Status: 1,
  AppVersionNumber: '1.0.0',
  ChangeLog: '',
  CategoryIds: [],
  Dependencies: '',
  AuthenticationType: 0,
  PriceType: PRICE_TYPE_ENUM['SUBSCRIPTION'],
  AnnuallyPrice: 0,
  MonthlyPrice: 0,
  PageSlots: [],
  EmbeddedUrl: '',
  PortalEmbeddedUrl: '',
  // Mobile fields
  AppConnectivityState: 0, // Default is Online
  MobileAppCode: '',
  BundleZipFile: null,
  BundleZipBlobReference: '',
  MobileBAUModuleIDs: [],
  MobileFeatureUrl: 'https://',
  MobileIntegrationMode: 1,
  AppId: 0,
  AppCodeImage: generateUUID(),
  AppCode: generateUUID(),
  AccessScope: ACCESS_SCOPE_ENUM['Tenant'],
};
